import { useForm } from "react-hook-form";
import { FormInput } from "../../shared/formElements/formInput/FormInput";
import { FormCheckboxChips } from "../../shared/formElements/formCheckBoxChip/FormCheckBoxChip";
import { FormImagePreviewAndUpload } from "../../shared/formElements/FormImagePreviewAndUpload/FormImagePreviewAndUpload";

import classes from "./orderDetailForm.module.css";
import { FormReadonlyContent } from "./formReadOnly/FormReadOnlyContent";

export const OrderDetailForm = ({ initialValues, onSubmit, isSubmitting }) => {
  const { register, watch, setValue } = useForm({
    defaultValues: initialValues,
  });

  const approvalStatus = watch("approval_status_code");

  const url = watch("url");

  const isApprovalChanged =
    approvalStatus !== initialValues.approval_status_code;

  const approvalOptions = [
    {
      id: "1",
      label: approvalStatus === "1" ? "Approved" : "Approve",
    },
    {
      id: "2",
      label: approvalStatus === "2" ? "Rejected" : "Reject",
    },
  ];

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const payload = {
      payment_id: initialValues.payment_id,
      status: approvalStatus,
      url,
    };
    console.log("Form submitted payload:", payload);
    onSubmit(payload);
  };

  return (
    <form className={classes.form} onSubmit={handleFormSubmit}>
      <div className={classes.columnsWrapper}>
        {/* LEFT */}
        <div className={classes.leftSection}>
          <h3 className={classes.sectionTitle}>Order Info</h3>

          {/* Read-only fields */}
          <FormInput
            id="order_id"
            label="Order ID"
            value={initialValues.order_id}
            readOnly
          />
          <FormInput
            id="payment_id"
            label="Payment ID"
            value={initialValues.payment_id}
            readOnly
          />
          {/* <FormCheckboxChips
            id="payment_status"
            label="Payment"
            options={[
              { id: "Paid", label: "Paid" },
              { id: "Pending", label: "Pending" },
              { id: "Cancelled", label: "Cancelled" },
            ]}
            watch={watch}
            setValue={setValue}
            register={register}
            disabled
          /> */}
          <FormInput
            id="transaction_id"
            label="Transaction ID"
            value={initialValues.transaction_id}
            readOnly
          />
          <FormInput
            id="rz_order_id"
            label="RazorPay Order ID"
            value={initialValues.rz_order_id}
            readOnly
          />
          <FormInput
            id="total_amount"
            label="Total Amount"
            value={initialValues.total_amount}
            readOnly
          />

          {/* Editable checkbox */}
          <FormCheckboxChips
            id="approval_status_code"
            label="Status"
            options={approvalOptions}
            watch={watch}
            setValue={setValue}
            register={register}
          />
          <div className={classes.section}>
            <h3 className={classes.sectionTitle}>Payment Image</h3>
            <FormImagePreviewAndUpload
              id="url"
              url={url}
              register={register}
              setValue={setValue}
            />
          </div>
        </div>

        {/* RIGHT */}
        <div className={classes.rightSection}>
          <h3 className={classes.sectionTitle}>Payment Gateway Details</h3>
          <FormReadonlyContent
            id="paymentDetails"
            label="Payment Details"
            content={initialValues?.payment_details}
            style={{ height: "848px" }}
            
          />
        </div>
      </div>

      {/* IMAGE */}

      {/* ACTIONS */}
      <div className={classes.actions}>
        <button
          type="submit"
          className={classes.submitBtn}
          disabled={!isApprovalChanged || isSubmitting} // ✅ disabled if not changed
        >
          {isSubmitting ? "Updating..." : "Update Order"}
        </button>
      </div>
    </form>
  );
};
